var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 641 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1443_3769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.286 6.34258C295.286 -1.25742 282.186 -1.25742 273.186 6.34258L9.18599 230.343C-0.91401 238.943 -2.11401 254.043 6.38599 264.143C14.886 274.243 30.086 275.443 40.186 266.943L64.786 246.143V432.643C64.786 476.843 100.586 512.643 144.786 512.643H395.586C377.286 499.743 361.486 483.443 349.286 464.643H336.786H240.786V320.643H327.386C332.186 303.543 339.586 287.443 349.086 272.843C347.686 272.643 346.186 272.643 344.786 272.643H232.786C210.686 272.643 192.786 290.543 192.786 312.643V464.643H144.786C127.086 464.643 112.786 450.343 112.786 432.643V205.443L288.786 56.1426L455.486 197.543C468.786 194.343 482.586 192.643 496.786 192.643C507.086 192.643 517.086 193.543 526.886 195.243L304.286 6.34258ZM640.786 368.643C640.786 330.451 625.615 293.824 598.609 266.819C571.604 239.814 534.977 224.643 496.786 224.643C458.595 224.643 421.968 239.814 394.963 266.819C367.957 293.824 352.786 330.451 352.786 368.643C352.786 406.834 367.957 443.461 394.963 470.466C421.968 497.471 458.595 512.643 496.786 512.643C534.977 512.643 571.604 497.471 598.609 470.466C625.615 443.461 640.786 406.834 640.786 368.643ZM564.086 325.343C570.286 331.543 570.286 341.743 564.086 347.943L492.086 419.943C485.886 426.143 475.686 426.143 469.486 419.943L429.486 379.943C423.286 373.743 423.286 363.543 429.486 357.343C435.686 351.143 445.886 351.143 452.086 357.343L480.786 386.043L541.486 325.343C547.686 319.143 557.886 319.143 564.086 325.343Z",
    fill: "#439BD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1443_3769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 512,
    fill: "#439BD9",
    transform: "translate(0.785156 0.642578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.3546743b7d3ed774eb7566b8ced7fdbd.svg";
export { ForwardRef as ReactComponent };